import { Link } from 'react-router-dom';
import { Card } from 'shared-ui/lib/components/Card';
import { Image } from 'shared-ui/lib/components/Image';
import { routesConfig } from '../../../config/routes.config';
import { HomeSceneQueryResult } from '../../../generated/graphql';
import { HomeCardVehicleName } from './HomeCardVehicleName';

type Props = {
  data: HomeSceneQueryResult['data'];
};

export const HomeCardVehicle = ({ data }: Props) => {
  return (
    <>
      {data?.vehicles.list.map((vehicle) => (
        <Link
          to={routesConfig.VEHICLES.SHOW.replace(':id', vehicle.id)}
          key={vehicle.id}
          className="h-full block min-h-0"
        >
          <Card className="h-full flex flex-col min-h-0">
            <HomeCardVehicleName vehicle={vehicle} />
            <div className="mt-1 w-full flex-1 min-h-0 flex flex-col">
              <div className="home-vehicle-card-photo-frame">
                <Image src={vehicle.photo} h={280} w={500} />
              </div>
            </div>
          </Card>
        </Link>
      ))}
    </>
  );
};
